import React from 'react';
import SelectPaymentMethod from '../SelectPayment';
function PaymentOption() {
  return <SelectPaymentMethod payNow={true} />;
}

export default PaymentOption;
